import { Helpdesk } from 'models/Helpdesk/helpdesk.model';
import { Product } from 'models/Product/product.model';
import React, { useContext, useEffect, useState } from 'react';
import styles from './Helpdesk.module.scss';
import Message from 'assets/ColorIcons/SVG/group_58673.svg';
import { helpDeskConstants } from './HelpDeskConstants';
import COButton from '../COButton';
import VideoModal from '../DemoVideoModal/VideoModal';
import DemoVideoService from 'services/DemoVideoService/demoVideo.service';
import { DemoVideoTypes } from 'enums/demoVideoEnums';
import LoaderAnimation from '../LoaderAnimation';
import { Commodity } from 'models/Farmbox/commodity.model';
import FarmIcon from 'assets/icons/farm.svg';

interface HelpDeskProps {
  product?: Product | undefined;
  helpDeskData: Helpdesk | null;
  loading?: boolean;
  isCommodity?: boolean;
  commodity?: Commodity;
  isLiveStock?: boolean;
}
const HelpDesk: React.FC<HelpDeskProps> = ({
  product,
  helpDeskData,
  loading,
  commodity,
  isCommodity,
  isLiveStock,
}: HelpDeskProps) => {
  const { fetchDemoVideoLink, demoVideos } = DemoVideoService();
  const [playVideo, setPlayVideo] = useState<boolean>(false);
  const { HELP_DESK, WHAT, WHERE, WHY, PLACEHOLDER_TEXT } = helpDeskConstants;
  useEffect(() => {
    fetchDemoVideoLink();
  }, []);
  const handleReportAnIssue = () => {
    const formLink =
      'https://docs.google.com/forms/d/e/1FAIpQLSc6npdT7jNnRHKhNPAY4ZTjy4uahDMaGko8rTB9oT49k_n68A/viewform?usp=sf_link';
    window.open(formLink, '_blank');
  };
  const demoVideoUrl = demoVideos?.find(
    item => item.type === DemoVideoTypes.PCF
  )?.url;

  const toggleVideoDisplay = () => setPlayVideo(prev => !prev);
  const desiredCommodityImage = commodity?.imageUrl
    ? commodity?.imageUrl
    : FarmIcon;

  return (
    <>
      <div className={styles.topContainer}>
        <div className={styles.topContentContainer}>
          <div className={styles.imageContainer}>
            <img
              src={isCommodity ? desiredCommodityImage : product?.image}
              alt={product?.name}
            />
          </div>
          <div className={styles.infoContainer}>
            <div className={styles.headingContainer}>
              <h2>{isCommodity ? commodity?.name : product?.name}</h2>
            </div>
            {!isLiveStock && (
              <div className={styles.valueContainer}>
                {isCommodity
                  ? `${commodity?.dryWeight} kg`
                  : `${product?.grossWeight} ${product?.netWeightUnit}`}
              </div>
            )}
          </div>
        </div>
        <div className={styles.reportIssueContainer}>
          <div className={styles.buttonContainer}>
            <COButton text onClick={handleReportAnIssue}>
              Report an issue
            </COButton>
          </div>
          <div className={styles.demoVideoContainer}>
            <COButton text onClick={toggleVideoDisplay}>
              Demo
            </COButton>
          </div>
        </div>
      </div>
      {loading ? (
        <div className={styles.loaderAnimation}>
          <LoaderAnimation />
        </div>
      ) : helpDeskData ? (
        <div className={styles.heldeskContentContainer}>
          <div className={styles.helpDeskHeading}>
            {/* <h3>{HELP_DESK}</h3> */}
            <h4>{helpDeskData?.input_field}</h4>
          </div>
          <div className={styles.helpDeskContent}>
            <h3>{WHAT}</h3>
            <p> {helpDeskData?.what}</p>
          </div>
          <div className={styles.helpDeskContent}>
            <h3>{WHERE}</h3>
            <p> {helpDeskData?.where_text}</p>
          </div>
          <div className={styles.helpDeskContent}>
            <h3>{WHY}</h3>
            <p> {helpDeskData?.why}</p>
          </div>
        </div>
      ) : (
        <div className={styles.heldeskContentContainer}>
          <div className={styles.placeHolderTextContainer}>
            <img src={Message} alt="message" />
            <h2>{PLACEHOLDER_TEXT}</h2>
          </div>
        </div>
      )}
      {playVideo && (
        <VideoModal
          isOpen={playVideo}
          videoUrl={demoVideoUrl ?? ''}
          onClose={toggleVideoDisplay}
        />
      )}
    </>
  );
};

export default HelpDesk;
